import { defineMessage } from 'react-intl';

export const youtubeCuepointsMessages = {
  pageTitle: defineMessage({
    id: 'youtube.cuepoints.pageTitle',
    defaultMessage: 'Cuepoints',
  }),
  manageCuepointsAlertTitle: defineMessage({
    id: 'youtube.cuepoints.manageCuepointsAlertTitle',
    defaultMessage: 'Cuepoints de YouTube',
  }),
  manageCuepoints: defineMessage({
    id: 'youtube.cuepoints.manageCuepoints',
    defaultMessage: 'Ver cuepoints registrados',
  }),
  columnCreatedAt: defineMessage({
    id: 'youtube.cuepoints.column.createdAt',
    defaultMessage: 'Fecha/hora de inserción',
  }),
  columnVideoId: defineMessage({
    id: 'youtube.cuepoints.column.videoId',
    defaultMessage: 'Video ID',
  }),
  columnCuepointId: defineMessage({
    id: 'youtube.cuepoints.column.cuepointId',
    defaultMessage: 'ID de cuepoint',
  }),
  insertButton: defineMessage({
    id: 'youtube.cuepoints.insert.button',
    defaultMessage: 'Insertar cuepoint',
  }),
  insertDialogTitle: defineMessage({
    id: 'youtube.cuepoints.insert.dialogTitle',
    defaultMessage: 'Insertar cuepoint manualmente',
  }),
  insertDurationLabel: defineMessage({
    id: 'youtube.cuepoints.insert.durationLabel',
    defaultMessage: 'Duración (segundos)',
  }),
  insertDurationHelper: defineMessage({
    id: 'youtube.cuepoints.insert.durationHelper',
    defaultMessage: 'Entre 1 y 300 segundos',
  }),
  insertDurationRequired: defineMessage({
    id: 'youtube.cuepoints.insert.durationRequired',
    defaultMessage: 'La duración es obligatoria',
  }),
  insertDurationMin: defineMessage({
    id: 'youtube.cuepoints.insert.durationMin',
    defaultMessage: 'La duración mínima es 1 segundo',
  }),
  insertDurationMax: defineMessage({
    id: 'youtube.cuepoints.insert.durationMax',
    defaultMessage: 'La duración máxima es 300 segundos',
  }),
  insertSubmit: defineMessage({
    id: 'youtube.cuepoints.insert.submit',
    defaultMessage: 'Insertar',
  }),
  insertSuccess: defineMessage({
    id: 'youtube.cuepoints.insert.success',
    defaultMessage: 'Cuepoint insertado correctamente',
  }),
  insertError: defineMessage({
    id: 'youtube.cuepoints.insert.error',
    defaultMessage: 'No se pudo insertar el cuepoint',
  }),
};
